import React, { useState, useEffect } from 'react';
import MasterPage from 'components/MasterPage';
import { Button, Card, Col, Form, FormControl, Row, Spinner } from 'react-bootstrap';
import { CreditCardOutlined } from '@material-ui/icons';
import DatePicker from 'react-datepicker';
import { Currency, currencyReverse } from 'helpers/Currency';
import { api } from 'services';
import CreditCardFormRevenues from './Revenues';
import Axios from 'axios';
import { formatDate, parseDateBR, parseToDate } from 'helpers/date';
import { useHistory } from 'react-router-dom';
import MyLoadStyle from './MyLoadStyle';
import swal from 'helpers/swal';
import { toast } from 'react-toastify';

class FiscalYear{
  constructor(){
    this.start = 2019;
    this.end = this.getEnd();

    this.listYear = this.getListYears();
  }

  getEnd(){
    let date = new Date();
    let year = date.getFullYear()
    if(date.getMonth() > 5){
      year = parseInt(year)+1;
    }
    return year;
  }
  getListYears(){
    let _r = [];
    let index = this.start;
    do {
      _r.push(index++)
    } while (index <= this.end);
    return _r;
  }
  getCurrentYear(){
    return this.listYear[this.listYear.length-1];
  }
  getRangeYear(year){
    return {
      from: `${parseInt(year)-1}-07-01`,
      to:`${parseInt(year)}-06-30`
    }
  }
}

const CreditCardForm = ({
  match: {
    params: { id }
  },
}) => {
  const [ classFiscalYear ] = useState(new FiscalYear());
  const filtersDefault = {
    task_id:[],
    year:classFiscalYear.getCurrentYear()
  }
  const [filters, setFilters] = useState(filtersDefault);
  const [object, setObject] = useState({
    list:[]
  });
  const [token_cancel_request, set_token_cancel_request] = useState(Axios.CancelToken.source());
  const [expenseDescriptions, setExpenseDescriptions] = useState({
    data:[],
    load:true
  });
  const [upload, setUpload] = useState(false);
  const history = useHistory();

  useEffect(()=>{
    setExpenseDescriptions({
      load:true,
      data:[]
    });
    let filters_aux = {...filters, ...classFiscalYear.getRangeYear(filters.year)};

    token_cancel_request.cancel('Não é mais de meu interesse enviar esta requisição.');
    let aux_token_cancel_request = Axios.CancelToken.source();
    set_token_cancel_request(aux_token_cancel_request);
    api.get('to-revenues',{params:filters_aux, cancelToken: aux_token_cancel_request.token}).then(({data})=>{
      let list = [...data];
      setExpenseDescriptions({
        load:false,
        data:list
      });
    }).catch((error)=>{

    });
  },[filters]);

  useEffect(()=>{
    if(id){
      api.get(`/credit-card/${id}`)
      .then(({data}) => {
        setObject({
          card_brand:data.card_brand,
          value:data.value,
          non_refundable:data.non_refundable,
          due_date:parseToDate(data.due_date),
          list:data.list,
          id:data.id,
          is_close:data.is_close
        });
      })
    }
  },[id]);

  const bandeiras = [
    {id:"Visa",name:"VISA"},
    {id:"Mastercard",name:"MASTERCARD"},
    {id:"Amex",name:"AMEX"},
  ];

  const setValue = (name, value) => {
    let obj = {...object};
    obj[name] = value;
    setObject({...obj});
  }

  const getValue = (name) => {
    let v = object[name];
    if(v){
      return v;
    }
    return '';
  }

  const disabled = !!id;

  const submit = async (e) => {
    setUpload(true);
    if(id){
      let formData = [];
      object.list.forEach((a,k)=>{
        formData.push({
          parent_type: a.parent_type,
          id: a.id,
          real_value: a.realValue
        });
      });
      
      api.put(`/credit-card/${id}`, formData)
      .then(({data}) => {
        setUpload(false);
      })
    } else {
      if(!object.card_brand) toast.error("Selecione a bandeira.", { autoClose: true });
      if(!object.value) toast.error("O campo Valor é obrigatório.", { autoClose: true });
      if(!object.due_date) toast.error("O campo Data de Vencimento é obrigatório.", { autoClose: true });
      if(!!object.card_brand && !!object.value && !!object.due_date){
        let a = await swal.confirmation('Aviso','Esses campos não poderão ser alterada posteriormente.<br/>Deseja continuar?');
        if(a.isConfirmed){
          const formData = new FormData();
          formData.append('card_brand', object.card_brand);
          formData.append('value', object.value);
          formData.append('non_refundable', object.non_refundable);
          formData.append('due_date', formatDate(object.due_date));
          
          api.post(`/credit-card/`, formData)
          .then(({data}) => {
            history.push('/creditcard/form/'+data.id);
            setUpload(false);
          })
        }
      }
    }
  }

  const close = async () => {
    setUpload(true);
    let a = await swal.confirmation('Aviso','Fechando não poderá mais ser feita alterações.<br/>Deseja continuar?');
    if(a.isConfirmed){
      let formData = [];
      object.list.forEach((a,k)=>{
        formData.push({
          parent_type: a.parent_type,
          id: a.id,
          real_value: a.realValue
        });
      });
      
      await api.put(`/credit-card/${id}`, formData);
      api.put(`/credit-card/${id}/close`)
      .then(({data}) => {
        setObject({
          card_brand:data.card_brand,
          value:data.value,
          due_date:parseToDate(data.due_date),
          list:data.list,
          id:data.id,
          is_close:data.is_close
        });
        setUpload(false);
      })
    } else {
      setUpload(false);
    }
  }

  if(!object.id && id){
    return <>
      <Row>
        <Col className="d-flex mt-3 mb-3">
          <CreditCardOutlined className="icon-title" />
          <h4 className="title-dashboard mt-2">Cartão de Credito</h4>
        </Col>
      </Row>
      <Card.Body className="shadow bg-white rounded mb-3">
        <Row className="justify-content-center">
          <Col xs="auto"><MyLoadStyle/></Col>
        </Row>
        <Row className="justify-content-center">
          <Col xs="auto">Carregando dados do Cartão</Col>
        </Row>
      </Card.Body>    
    </>;
  }

  const blockBtn = () => {
    let total = 0;
    object.list.forEach(a=>{total += a.realValue?a.realValue:a.value;});
    return object.value < total;
  }

  return <>
    <Row>
      <Col className="d-flex mt-3 mb-3">
        <CreditCardOutlined className="icon-title" />
        <h4 className="title-dashboard mt-2">Cartão de Credito</h4>
      </Col>
    </Row>
    <Card.Body className="shadow bg-white rounded mb-3">
      <Form>
        <Row>
          <Col>
            <Form.Group>
              <Form.Label>Bandeira</Form.Label>
              <FormControl
                as="select"
                value={getValue('card_brand')}
                onChange={e => setValue('card_brand',e.target.value)}
                required
                disabled={disabled}
              >
                <option disabled={true} value="">
                  Selecione
                </option>
                {bandeiras.map((b, k) => (
                  <option key={k} value={b.id}>
                    {b.name}
                  </option>
                ))}
              </FormControl>
            </Form.Group>
          </Col>
          <Col>
            <Form.Group>
              <Form.Label>Data de Vencimento</Form.Label>
              <DatePicker
                className="form-control"
                dateFormat="dd/MM/yyyy"
                locale="pt_BR"
                selected={getValue("due_date")}
                onChange={(e) => setValue("due_date",e)}
                disabled={disabled}
              />
            </Form.Group>
          </Col>
        </Row>
        <Row>
          <Col md="4">
            <Form.Group>
              <Form.Label>Valor - Reembolsável</Form.Label>
              <Currency
                value={getValue('value')}
                onChange={(e) => setValue('value',currencyReverse(e.target.value))}
                disabled={disabled}
              />
            </Form.Group>
          </Col>
          <Col md="4">
            <Form.Group>
              <Form.Label>Valor - Não Reembolsável</Form.Label>
              <Currency
                value={getValue('non_refundable')}
                onChange={(e) => setValue('non_refundable',currencyReverse(e.target.value))}
                disabled={disabled}
              />
            </Form.Group>
          </Col>
          <Col md="4">
            <Form.Group>
              <Form.Label>total</Form.Label>
              <Currency
                value={getValue('value') + getValue('non_refundable')}
                disabled={true}
              />
            </Form.Group>
          </Col>
        </Row>
        {id?(<>
          <Form.Label>Fatura</Form.Label>
          <CreditCardFormRevenues 
            list={expenseDescriptions} 
            listSelected={object.list}
            onChange={(list)=>setValue('list',list)}
            filters={filters}
            setFilters={setFilters}
            close={object.is_close}
            card={object}
            listYear={classFiscalYear.getListYears()}
          />
        </>):''}
        {upload?<>
          <Spinner animation="border" />
        </>:<>
          {object.is_close?"":(
            <Row>
              <Button variant="dark" onClick={()=>{
                submit()
              }} className="ml-3">
                Salvar
              </Button>
              {id?(
                <Button variant="dark" onClick={()=>{
                  close()
                }} className="ml-3" disabled={blockBtn()}>
                  Fechar Fatura
                </Button>
              ):''}
            </Row>
          )}
        </>}
      </Form>
    </Card.Body>

  </>;
}

export default MasterPage(CreditCardForm);